import { Outlet, Link } from "react-router-dom";
import Logo from './assets/thumbnail2.jpg';
import footerLogo from './assets/thumbnail.png';
import { PopupButton } from "react-calendly";
import { useState, useEffect } from "react";
import Hamburger from "./Hamburger";
import NewModal from "./newModal";
import taxplannar from "./assets/2023 Tax Organizer.pdf"

export default function Layout() {
    const [hamburgerOpen, setHamburgerOpen] = useState(true)


    function getCurrentDimension(){
        return {
              width: window.innerWidth,
              height: window.innerHeight
        }
    }

    const [screenSize, setScreenSize] = useState(getCurrentDimension());
    const [modalShow, setModalShow] = useState(true);


    useEffect(() => {
        const updateDimension = () => {
          setScreenSize(getCurrentDimension())
        }
        window.addEventListener('resize', updateDimension);
        
        return(() => {
            window.removeEventListener('resize', updateDimension);
        })
      }, [screenSize]);
    
    useEffect(() => {
        if (screenSize.width > 900) {
            setHamburgerOpen(true);
        }
        else {
            setHamburgerOpen(false);
        }
      }, [screenSize]);


    function toggleHamburger() {
        setHamburgerOpen(!hamburgerOpen);
    }

    function closeOnTabClick() {
        if (screenSize.width < 900) {
            setHamburgerOpen(false)
        }
    }
    return (
        <>
        <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.0/css/bootstrap.min.css" 
            integrity="sha384-9gVQ4dYFwwWSjIDZnLEWnxCjeSWFphJiwGPXr1jddIhOegiu1FwO5qRGvFXOdJZ4" 
            crossorigin="anonymous"></link>
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" rel="stylesheet"></link>
            <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.bundle.min.js"></script>
            <script src="https://kit.fontawesome.com/d54202a280.js" crossorigin="anonymous"></script>
        </head>

        {hamburgerOpen && 
            <div className="navbar navbar-expand-md navbar-expand-md bg-white sticky-top d-flex justify-content-between align-items-center ps-xl-5 pe-xl-5">
                <div className="col-1 ps-5 ms-5">
                    <Link to="/" ><img src={Logo} className="logoNavbar" alt="thumbnail"/></Link>
                </div>
                
                <div className="col me-5 d-flex justify-content-end align-items-center">
                        <ul className="navbar-nav d-flex justify-content-end align-items-center">
                            <li className="nav-item nav-link active"><Link to="/" className="nav-link" onClick={closeOnTabClick}>Home</Link></li>
                            <li className="nav-item nav-link"><Link to="/about" className="nav-link" onClick={closeOnTabClick}>About Us</Link></li>
                            <li className="nav-item nav-link"><Link to="/services" className="nav-link" onClick={closeOnTabClick}>Services</Link></li>
                            <li className="nav-item nav-link"><Link to="/resources" className="nav-link" onClick={closeOnTabClick}>Resources</Link></li>
                            <li className="nav-item nav-link"><Link to="/contact" className="nav-link" onClick={closeOnTabClick}>Contact Us</Link></li>
                            <li className="nav-item p-2">
                                <Link href="https://assets.calendly.com/assets/external/widget.css" rel="stylesheet" />
                                <script src="https://assets.calendly.com/assets/external/widget.js" type="text/javascript" async></script>
                                <PopupButton
                                    className="btn btn-outline-primary p-lg-2"
                                    url="https://calendly.com/ftconsultants/30min?hide_event_type_details=1&hide_gdpr_banner=1"
                                    rootElement={document.getElementById("root")}
                                    text="Book Appointment"
                                />
                            </li>
                            <li className="nav-item p-2">
                            <button variant="primary" className='btn btn-outline-primary p-lg-2' onClick={() => setModalShow(true)}>
                                What's New
                            </button>
                            <NewModal 
                                show={modalShow} 
                                onHide={() => setModalShow(false)} 
                            />
                            </li>
                            <li className="nav-item p-2">
                            <a className='btn btn-outline-primary p-lg-2' href={taxplannar} download="tax-plannar-2023">
                                Tax Plannar-2023
                            </a>
                            </li>
                        </ul>
                        <div className='hamburger' onClick={toggleHamburger}>
                            <Hamburger />
                        </div>
                </div>
            </div>
        }
        {!hamburgerOpen && 
            <div className='sticky-top bg-white d-flex justify-content-between '>
                <div className="col-1 ms-lg-5">
                    <Link to="/" ><img src={Logo} className="logoNavbar" alt="thumbnail" /></Link>
                </div>
                <div className='hamburger pe-5' onClick={toggleHamburger}>
                    <Hamburger />
                </div>
            </div>
                
        }

        <Outlet />

        <hr />
        <footer className="container-fluid py-5 bg-light">
            <div className="row">
                <div className="col-lg-6 text-center">
                    <img src={footerLogo} className="imgFooter" alt="thumbnail"/>
                    <small className="d-block mb-3 text-muted">&copy; Finance & Technology Consultants, Inc</small>
                </div>
                <div className="col-lg-1 p-3">
                    <div className="h5 text-start">About F&T Consultants </div>
                    <ul className="list-unstyled text-small text-start">
                        <li className="nav-item nav-link active"><Link to="/" className="footerLink">Home</Link></li>
                        <li className="nav-item nav-link"><Link to="/about" className="footerLink">About Us</Link></li>
                        <li className="nav-item nav-link"><Link to="/services" className="footerLink">Services</Link></li>
                        <li className="nav-item nav-link"><Link to="/resources" className="footerLink">Resources</Link></li>
                        <li className="nav-item nav-link"><Link to="/contact" className="footerLink">Contact Us</Link></li>
                    </ul>
                </div>

                <div className="col-lg-1 p-3">
                    <div className="h5 text-start">Useful Links</div>
                    <ul className="list-unstyled text-small text-start">
                        <li className="nav-item nav-link"><a className="footerLink" href="http://www.irs.gov" target="_blank" rel="noreferrer">Internal Revenue Services</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.irs.gov/refunds" target="_blank" rel="noreferrer">Check your Refunds</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.irs.gov/forms-instructions" target="_blank" rel="noreferrer">Forms and Instructions</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.irs.gov/individuals/tax-withholding-estimator" target="_blank" rel="noreferrer">Withholding Calculators</a></li>
                    </ul>
                </div>

                <div className="col-lg-1 p-3">
                    <div className="h5 text-start">States</div>
                    <ul className="list-unstyled text-small text-start">
                        <li className="nav-item nav-link"><a className="footerLink" href="https://floridarevenue.com/Pages/default.aspx" target="_blank" rel="noreferrer">Florida</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.tax.ny.gov/" target="_blank" rel="noreferrer">New York State</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.ftb.ca.gov/" target="_blank" rel="noreferrer">California</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.tax.virginia.gov/" target="_blank" rel="noreferrer">Virginia</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.state.nj.us/treasury/taxation/" target="_blank" rel="noreferrer">New Jersey</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://otr.cfo.dc.gov/" target="_blank" rel="noreferrer">Washington DC</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://comptroller.texas.gov/taxes/" target="_blank" rel="noreferrer">Texas</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://tax.nv.gov/" target="_blank" rel="noreferrer">Nevada</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://revenue.wyo.gov/" target="_blank" rel="noreferrer">Wyoming</a></li>
                    </ul>
                </div>

                <div className="col-lg-1 p-3">
                    <div className="h5 text-start">Accounting Softwares</div>
                    <ul className="list-unstyled text-small text-start">
                        <li className="nav-item nav-link active"><a className="footerLink" href="https://quickbooks.intuit.com/" target="_blank" rel="noreferrer">Quickbooks</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.sage.com/en-us/" target="_blank" rel="noreferrer">Sage</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.xero.com/us/" target="_blank" rel="noreferrer">Xero</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.waveapps.com/" target="_blank" rel="noreferrer">Wave</a></li>
                        <li className="nav-item nav-link"><a className="footerLink" href="https://www.freshbooks.com/" target="_blank" rel="noreferrer">FreshBooks</a></li>
                    </ul>
                </div>
            </div>
        </footer>
        </>
    );
}

